<!-- FOOTER -->
<footer class="bg-ink text-paper">
  <div class="max-w-7xl mx-auto px-8 py-14 lg:py-20">
    <div class="grid gap-x-8 gap-y-12 lg:grid-cols-12 lg:gap-x-6">
      <!-- Brand / Mission -->
      <div class="lg:col-span-4 lg:pr-6">
        <a
          routerLink="/"
          class="inline-flex items-center gap-3 select-none"
          aria-label="Orient House"
        >
          <img
            src="/assets/ohdc-logo white.svg"
            alt="Orient House for Development & Constructions"
            class="h-16 w-auto lg:h-18 select-none"
            draggable="false"
          />
        </a>
        <p class="mt-5 text-white/60 text-sm leading-relaxed max-w-sm">
          UAE-born contractor delivering governed, safe, and on-time outcomes
          across residential, Civil, marine/topside, and infrastructure
          projects.
        </p>

        <!-- Socials -->
        <div class="mt-7 flex items-center gap-3">
          <a
            href="https://www.linkedin.com/company/orient-house-for-development-&-construction-llc/"
            target="_blank"
            rel="noopener"
            aria-label="LinkedIn"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white transition hover:bg-white/10"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" class="size-4" aria-hidden="true">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
          <a
            href="https://www.facebook.com/people/Orient-House-for-Development-Constructions/61595227572136/"
            target="_blank"
            rel="noopener"
            aria-label="Facebook"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white transition hover:bg-white/10"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" class="size-4" aria-hidden="true">
              <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647Z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/ohdcinfo/"
            target="_blank"
            rel="noopener"
            aria-label="Instagram"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white transition hover:bg-white/10"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" class="size-4" aria-hidden="true">
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
            </svg>
          </a>
        </div>
      </div>

      <!-- Company -->
      <div class="lg:col-span-2">
        <h4
          class="text-xs font-semibold uppercase tracking-[0.16em] text-white/50"
        >
          Company
        </h4>
        <ul class="mt-5 space-y-3 text-sm">
          <li>
            <a routerLink="/" class="text-white/70 hover:text-white transition"
              >Home</a
            >
          </li>
          <li>
            <a
              routerLink="/about"
              class="text-white/70 hover:text-white transition"
              >About</a
            >
          </li>
          <li>
            <a
              routerLink="/clients"
              class="text-white/70 hover:text-white transition"
              >Clients</a
            >
          </li>
          <!-- <li>
            <a
              href="/assets/downloads/ohdc-company-profile.pdf"
              target="_blank"
              rel="noopener"
              class="text-white/70 hover:text-white transition"
              >Company Profile (PDF)</a
            >
          </li> -->
        </ul>
      </div>

      <!-- Explore -->
      <div class="lg:col-span-3">
        <h4
          class="text-xs font-semibold uppercase tracking-[0.16em] text-white/50"
        >
          Explore
        </h4>
        <ul class="mt-5 space-y-3 text-sm">
          <li>
            <a
              routerLink="/services"
              class="text-white/70 hover:text-white transition"
              >Services</a
            >
          </li>
          <li>
            <a
              routerLink="/projects"
              class="text-white/70 hover:text-white transition"
              >Projects</a
            >
          </li>
          <li>
            <a
              routerLink="/hse"
              class="text-white/70 hover:text-white transition"
              >HSE</a
            >
          </li>
          <li>
            <a
              routerLink="/quality"
              class="text-white/70 hover:text-white transition"
              >Quality</a
            >
          </li>
          <li>
            <a
              routerLink="/blogs"
              class="text-white/70 hover:text-white transition"
              >Blogs</a
            >
          </li>
          <li>
            <a
              routerLink="/careers"
              class="text-white/70 hover:text-white transition"
              >Careers</a
            >
          </li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="lg:col-span-3">
        <h4
          class="text-xs font-semibold uppercase tracking-[0.16em] text-white/50"
        >
          Contact
        </h4>
        <div class="mt-5 space-y-3 text-sm">
          <p class="text-white/70 leading-relaxed">
            Orient House for Development &amp; Constructions Co. LLC<br />
            Abu Dhabi, United Arab Emirates
          </p>
          <a
            href="tel:+97124437879"
            class="block text-white hover:text-white/80 transition"
            >+971 2 443 7879</a
          >
          <a
            href="mailto:ohdcinfo@ohdc.ae"
            class="block text-white hover:text-white/80 transition"
            >ohdcinfo&#64;ohdc.ae</a
          >
          <p class="text-white/70">Sunday to Friday, 8:00 AM – 5:00 PM</p>
        </div>

        <!-- Small CTA -->
        <!-- <div class="mt-6">
          <a
            routerLink="/contact"
            class="group relative inline-flex items-center justify-center px-6 h-11 rounded-full bg-paper text-ink text-sm font-medium border border-transparent overflow-hidden transition-all duration-300 hover:bg-orientBlue hover:text-white hover:border-white/20 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-black/20 active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white/30 before:absolute before:inset-0 before:bg-[linear-gradient(120deg,transparent,rgba(255,255,255,.25),transparent)] before:-translate-x-full hover:before:translate-x-full before:transition-transform before:duration-700"
          >
            <span class="relative z-10"> Request a proposal </span>
          </a>
        </div> -->
      </div>
    </div>
  </div>

  <!-- Bottom bar -->
  <div class="border-t border-white/10">
    <div
      class="mx-auto flex max-w-7xl flex-col items-center gap-3 px-6 py-6 text-xs text-white/50 sm:flex-row sm:justify-between lg:px-8"
    >
      <p>&copy; {{ currentYear }} Orient House. All rights reserved.</p>
      <a
        href="http://truted.com"
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-1.5 text-white/50 transition hover:text-white/80"
      >
        Developed by
        <img
          src="https://truted.com/assets/trutedlogo.svg"
          alt="TruTed"
          class="h-3 w-auto opacity-80"
        />
      </a>
    </div>
  </div>
</footer>
